import { useEffect } from 'react';
import FormInputs from './CreateFormInputEventMlt.js'
import FooterMlt from './FooterMlt.js'
import useFormContext from './useFormEventMltComplete.js'
import HeaderMlt from './HeaderMlt.js'
import RequestHeaderEventMlt from './RequestHeaderEventMltComplete.js'
import { NavigationEventMltComplete } from './NavigationEventMltComplete.js'
const GetEventMltDetails = () => {

    const {
        eventFormData,
        getEventById,
        handlepageChange
    } = useFormContext()

    useEffect(() => {
        var res = window.location.href.split('/');
        eventFormData.eventId = res[res.length - 1]
        getEventById(eventFormData.eventId)
        if (res[res.length - 2] == 'guest') {
            handlepageChange(2);
        } else
        if (res[res.length - 2] == 'comment') {
            handlepageChange(3);
        } else
        if (res[res.length - 2] == 'postevent') {
            handlepageChange(4);
        }
    }, []);

    const content = (
        <form id="getDetailsAdminForm" className="form flex-col">
            <div>
                <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.8/dist/css/bootstrap.min.css" rel="stylesheet"
                    integrity="sha384-QWTKZyjpPEjISv5WaRU9OFeRpok6YctnYmDr5pNlyT2bRjXh0JMhjY6hW+ALEwIH" crossOrigin="anonymous"></link>
                <div className='container-fluid-custom'>
                    <HeaderMlt />
                    <RequestHeaderEventMlt />
                    <div className="container-fluid">
                        <div className="row m-1 mb-5">
                            <div className="col-md-2 p-0">
                                <NavigationEventMltComplete />
                            </div>
                            <FormInputs />
                        </div>
                    </div>
                    <FooterMlt/>
                </div>
            </div>
        </form>
    )
    return content
}
export default GetEventMltDetails